import ExcelJS from "exceljs";
const FORMATS = { money: '#,##0.00 "DA"', percent: "0%", qty: "#,##0.000", int: "0", date: "dd/mm/yyyy", text: "@" };
const argb = (hex) => "FF" + hex.replace("#", "").toUpperCase();
export function buildWorkbook(spec) {
    const wb = new ExcelJS.Workbook();
    wb.creator = spec.entity;
    wb.created = new Date();
    const primary = argb(spec.primaryColor ?? "#2F2F76");
    const accent = argb(spec.accentColor ?? "#009640");
    for (const s of spec.sheets) {
        const ws = wb.addWorksheet(s.name.slice(0, 31), { views: [{ state: "frozen", ySplit: 4 }], pageSetup: { paperSize: 9, orientation: s.columns.length > 7 ? "landscape" : "portrait", fitToPage: true, fitToWidth: 1, fitToHeight: 0, printTitlesRow: "4:4" } });
        const last = s.columns.length;
        ws.mergeCells(1, 1, 1, last);
        ws.getCell(1, 1).value = spec.entity.toUpperCase();
        ws.getCell(1, 1).font = { name: "Calibri", size: 14, bold: true, color: { argb: primary } };
        ws.mergeCells(2, 1, 2, last);
        ws.getCell(2, 1).value = s.title;
        ws.getCell(2, 1).font = { name: "Calibri", size: 12, bold: true, color: { argb: accent } };
        ws.mergeCells(3, 1, 3, last);
        ws.getCell(3, 1).value = s.subtitle ?? "";
        ws.getCell(3, 1).font = { name: "Calibri", size: 9, italic: true, color: { argb: "FF5B5F73" } };
        const header = ws.getRow(4);
        s.columns.forEach((c, i) => {
            const cell = header.getCell(i + 1);
            cell.value = c.header;
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: primary } };
            cell.alignment = { vertical: "middle", wrapText: true, horizontal: c.format && c.format !== "text" && c.format !== "date" ? "right" : "left" };
            ws.getColumn(i + 1).width = c.width ?? (c.format ? 14 : 28);
            if (c.format)
                ws.getColumn(i + 1).numFmt = FORMATS[c.format];
        });
        header.height = 22;
        s.rows.forEach((r, idx) => {
            const row = ws.getRow(5 + idx);
            s.columns.forEach((c, i) => {
                const v = r[c.key];
                row.getCell(i + 1).value = v instanceof Date || typeof v === "number" || typeof v === "string" || v == null ? v : String(v);
                if (idx % 2 === 1)
                    row.getCell(i + 1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3FD" } };
                row.getCell(i + 1).border = { bottom: { style: "hair", color: { argb: "FFD9DAEA" } } };
            });
        });
        const first = 5;
        const lastRow = 4 + s.rows.length;
        if (s.totals && s.rows.length) {
            const tr = ws.getRow(lastRow + 1);
            tr.getCell(1).value = "TOTAUX";
            tr.getCell(1).font = { bold: true };
            s.columns.forEach((c, i) => {
                const fn = s.totals?.[c.key];
                if (!fn)
                    return;
                const col = ws.getColumn(i + 1).letter;
                tr.getCell(i + 1).value = { formula: `${fn.toUpperCase()}(${col}${first}:${col}${lastRow})`, result: undefined };
                tr.getCell(i + 1).font = { bold: true, color: { argb: primary } };
            });
        }
        ws.autoFilter = { from: { row: 4, column: 1 }, to: { row: Math.max(4, lastRow), column: last } };
        if (s.legend) {
            const lr = ws.getRow(lastRow + 3);
            lr.getCell(1).value = s.legend;
            lr.getCell(1).font = { size: 9, italic: true, color: { argb: "FF8A8EA6" } };
        }
        ws.headerFooter.oddFooter = `&L${spec.entity} — ${s.title}&RPage &P / &N`;
    }
    return wb;
}
export async function workbookToBuffer(wb) {
    return new Uint8Array(await wb.xlsx.writeBuffer());
}
//# sourceMappingURL=excel.js.map